export default {"src":"/_next/static/media/import-factoring.002f5d44.svg","height":432,"width":552};